import React from 'react';
import usePrograms from '@/hooks/api/v2/usePrograms';
import { LessonSchema } from '@/types/api/v2/LessonSchema';

type Lesson = LessonSchema<
  'id'
  | 'unit_id'
  | 'title_with_position'
  | 'image_url'
  | 'title_number'
  | 'title',
  'program_ids'>;

interface LessonConfirmationProps {
  lesson: Lesson;
  referenceMaterial: {
    id: number;
    title: string;
  };
}

const LessonConfirmation = ({ lesson, referenceMaterial }: LessonConfirmationProps) => {
  const { data: programs } = usePrograms({
    extra_attributes: ['lesson_ids'],
    only: ['full_title_with_edition', 'id', 'code'],
    params: { order: 'title_en', page: 1, per_page: 500 },
  });

  const programsForLesson = programs.filter(program => lesson.program_ids.includes(program.id));

  return (
    <div>
      <p className="tw-m-0">
        The lesson
        {' '}
        <span className="tw-font-bold">{lesson.title}</span>
        {' '}
        is also reused in:
      </p>
      <ul className="tw-flex tw-flex-col tw-ml-8 tw-my-5 tw-gap-1">
        {programsForLesson.map(program => (
          <li key={program.id}>
            {program.full_title_with_edition} -- Lesson {program.lesson_ids.findIndex(id => id === lesson.id) + 1}
          </li>
        ))}
      </ul>
      <p>
        <span className="tw-font-bold">{referenceMaterial.title}</span>
        {' '}
        will also be associated with the programs above.
      </p>
    </div>
  );
};

export default LessonConfirmation;
